import React from "react"

import Link from "../utilities/link"
import { IconMixin } from "./styles"

export const Resume = props => (
  <Link
    to={`MariaSzubski_FrontEndDeveloper_Resume.pdf`}
    target="_blank"
    title="Resume"
  >
    <svg
      width="4.8rem"
      height="4.8rem"
      viewBox="0 0 48 48"
      css={IconMixin}
      role="img"
      aria-label="Download Resume PDF"
      {...props}
    >
      <circle cx={24} cy={24} r={24} className="fill-bg" />
      <path
        className="fill-ring"
        d="M24 1.3c12.537 0 22.7 10.163 22.7 22.7S36.537 46.7 24 46.7 1.3 36.537 1.3 24C1.314 11.469 11.469 1.314 24 1.3M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0z"
      />
      <path
        className="fill-icon"
        d="M13.34 30.35c-1.04-.586-1.84-1.427-2.4-2.52-.56-1.094-.84-2.373-.84-3.84s.28-2.743.84-3.83a5.937 5.937 0 012.4-2.511c1.04-.586 2.253-.88 3.64-.88 1.747 0 3.253.48 4.52 1.44.2.16.34.32.42.479.08.16.12.36.12.601 0 .347-.097.644-.29.89-.193.247-.43.37-.71.37a1.54 1.54 0 01-.49-.07 1.89 1.89 0 01-.47-.25c-.533-.347-1.027-.597-1.48-.75a4.567 4.567 0 00-1.46-.229c-1.28 0-2.244.396-2.89 1.189-.647.794-.97 1.978-.97 3.551 0 3.173 1.287 4.76 3.86 4.76.493 0 .96-.077 1.4-.23.44-.153.953-.403 1.54-.75.2-.12.367-.203.5-.25.133-.046.287-.069.46-.069.28 0 .517.123.71.369.193.247.29.544.29.891a1.3 1.3 0 01-.13.609 1.492 1.492 0 01-.41.471c-1.267.96-2.773 1.439-4.52 1.439-1.387 0-2.6-.293-3.64-.88zM35.581 17.041c.227-.141.479-.21.76-.21.399 0 .76.133 1.08.399.319.268.479.594.479.98 0 .2-.047.399-.14.6l-5.4 11.4a1.579 1.579 0 01-.659.71c-.294.166-.614.25-.961.25s-.666-.084-.96-.25a1.579 1.579 0 01-.659-.71l-5.4-11.4a1.287 1.287 0 01-.14-.58c0-.399.167-.732.5-1a1.743 1.743 0 011.12-.399c.279 0 .536.069.77.21.233.14.41.35.53.63l4.279 9.36 4.28-9.36c.12-.281.293-.491.521-.63z"
      />
    </svg>
  </Link>
)
